import React, { useContext, useState } from "react";
import MakroskopLink from "./makroskop-link";
import LoginLink from "./login-link";
import BookmarksLink from "./bookmarks-link";
import SearchButton from "./search-button";
import MenuLink from "./menu-link";
import TextLinks from "./text-links";
import useCmsEdition from "../../hooks/use-cms-edition";
import LoginPopup from "../common/login-popup";
import AnnouncementBanner from "../announcement-banner";
import { useActiveBanner } from "../../hooks/use-active-banner";
import useCmsSpotlight from "../../hooks/use-cms-spotlight";
import { useIsEditionSpotlightMagazine } from "../../hooks/use-is-edition-spotlight-magazine";
import AuthContext from "../../services/firebase/auth-context/provider";
const Header = _ref => {
    let { onOpenSearch, setVisibility } = _ref;
    const colorsMap = {
        "is-magazine": "makroYellow",
        "is-spotlight": "makroRedPortuguese",
        "is-edition": "makroBlue"
    };
    const { 0: loginPopupStatus, 1: setPopupStatus } = useState(false);
    const { authenticated } = useContext(AuthContext)[0];
    const edition = useCmsEdition().allDatoCmsEdition.edges[0].node;
    const spotlight = useCmsSpotlight();
    const banner = useActiveBanner();
    const loginIconColor = colorsMap[useIsEditionSpotlightMagazine()];
    const paddingBottom = banner ? "" : `pb-6 md:pb-12`;
    return /*#__PURE__*/ React.createElement("header", {
        className: `pt-5 bg-white flex flex-wrap relative ${paddingBottom}`
    }, /*#__PURE__*/ React.createElement("div", {
        className: "contents",
        onClick: () => setVisibility(false)
    }, /*#__PURE__*/ React.createElement(MakroskopLink, {
        className: "w-1/2 pr-6 lg:w-1/3"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "w-1/2 lg:w-2/3"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-xs text-right flex flex-wrap justify-end lg:mb-0"
    }, /*#__PURE__*/ React.createElement(LoginLink, {
        onClick: () => setPopupStatus(true),
        color: authenticated ? loginIconColor : "makroOrange"
    }), /*#__PURE__*/ React.createElement(BookmarksLink, null), /*#__PURE__*/ React.createElement(SearchButton, {
        openSearch: onOpenSearch,
        style: {
            marginTop: "-5px"
        }
    }), /*#__PURE__*/ React.createElement(MenuLink, {
        edition: edition
    })), /*#__PURE__*/ React.createElement(TextLinks, {
        edition: edition,
        spotlight: spotlight
    })), /*#__PURE__*/ React.createElement(LoginPopup, {
        shouldShowPopup: loginPopupStatus,
        onClose: () => setPopupStatus(false)
    }), /*#__PURE__*/ React.createElement(AnnouncementBanner, null));
};
export default Header;
